import dayjs from 'dayjs';
export default {
    methods: {
        formattedDate (date, format) {
            if (format === "Noday") {
                return date ? dayjs(date).format('Do MMM YY') : ''
            } else {
                return date ? dayjs(date).format('ddd DD MMM YY') : ''
            }
        },
    }
    
}